module.exports = __webpack_public_path__ + "img/nav.69ffbfa6.jpg";